var Curriculog = Curriculog || {};

Curriculog.Params = (function ($, _, Backbone, Params) {

	Params = Backbone.Collection.extend({

		model: Curriculog.Param,

		initialize: function(models, options) {
			this.queryParams = options.queryParams;
			this.domParams = options.domParams;
			this.pagingParams = options.pagingParams;
			this.paramsLoadedFromSession = false;
			this.user = options.user;
			this.localstorage = this.localstorage();
      this.cui_enabled = options.cui_enabled;

			this.listenTo(Backbone, 'user:logout', this.logOut);
		},

		fetch: function(level) {
			// Override fetch to use localstorage
			// Compare time in microseconds and if less than 1 day,
			// use the search params
			if (this.localstorage) {
				var key = (level == 'admin') ? 'adminParams' : 'userParams',
				       params = JSON.parse(this.localstorage.getItem(key)),
				       now = new Date().getTime().toString(),
				       user = this.user.id;

				if (params !== null) {
					var timeUnderOneDay = ((now - params.timestamp) / (1000 * 24 * 60 * 60)) < 1;

					if (user.id === params.user && timeUnderOneDay) {
						this.paramsLoadedFromSession = true;

						return params;
					}
				}

				this.deleteSession(level);
			}

			return {};
		},

		localstorage: function () {
			//Better feature detect as shown here: https://mathiasbynens.be/notes/localstorage-pattern
			var uid = new Date,
			       storage,
			       result;

			try {
				(storage = window.localStorage).setItem(uid, uid);
				result = storage.getItem(uid) == uid;
				storage.removeItem(uid);
				return result && storage;
			} catch (exception) {}
		},

		setSession: function(level) {
			if (this.localstorage) {
				var key = (level == 'admin') ? 'adminParams' : 'userParams';
				var params = JSON.stringify({params: this.compose(), timestamp: new Date().getTime()});
				this.localstorage.setItem(key, params);
			}
		},

		deleteSession: function(level) {
			if (this.localstorage) {
				var key = (level == 'admin') ? 'adminParams' : 'userParams';
				this.localstorage.removeItem(key);
			}
		},

		logOut: function() {
			if (this.localstorage) {
				var that = this;
				_.each(['userParams', 'adminParams'], function(key) {
					that.localstorage.removeItem(key);
				});
			}

		},

		matchTab: function(sessionQuery, tabParam) {
			/*
				(USER SIDE ONLY) Check if the url params are either:
					- empty
					- the same tab as in session
			*/
			var sessionTab = sessionQuery.params.domParams.tab;
			if (! _.isEmpty(tabParam) && (sessionTab == tabParam)) {
				return true;
			} else if (_.isEmpty(tabParam)) {
				return true;
			}
			return false;
		},

		populateModels: function(response) {
			this.queryParams.setAttr(response.params.queryParams);
			this.domParams.setAttr(response.params.domParams);
			this.pagingParams.setAttr(response.params.pagingParams);
		},

		compose: function() {
			var composition = {
				queryParams: this.queryParams.attributes,
				domParams: this.domParams.attributes,
				pagingParams: this.pagingParams.attributes,
				user: this.user.id
			};
			return composition;
		},

		paramsData: function() {
			var queryParams = this.queryParams.attributes;
			var pagingParams = this.pagingParams.attributes;
			var compositeParams = _.extend({}, queryParams, pagingParams);
			return compositeParams;
		}

	});

	return Params;

})($, _, Backbone, Curriculog.Params || {});
